module.exports = __webpack_public_path__ + "static/media/Azusa_v2_alpha@2x.059f297a.png";